import axios from 'axios'

export default {
  namespaced: true,

  state: {
    matchGames: []
  },

  getters: {
    matchGames (state) {
      return state.matchGames.sort((a, b) => {
        if (a.id < b.id) {
          return -1
        } else if (a.id > b.id) {
          return 1
        }

        return 0
      })
    }
  },

  mutations: {
    SET_MATCH_GAMES (state, matchGames) {
      state.matchGames = matchGames.map((row) => {
        row.shouldEdit = false
        return row
      })
    },

    UPDATE_MATCH_GAME (state, matchGame) {
      let index = state.matchGames
        .findIndex((row) => { return row.id === matchGame.id })
      if (index !== -1) {
        state.matchGames[index] = matchGame
      }
    },

    DELETE_MATCH_GAME (state, id) {
      let index = state.matchGames
        .findIndex((row) => { return row.id === id })

      if (index !== -1) {
        state.matchGames.splice(index, 1)
      }
    }
  },

  actions: {
    async get ({ commit }, params) {
      let matchGames = await axios.get('match-games', { params })
      commit('SET_MATCH_GAMES', matchGames.data)
    },

    async create ({ commit }, matchGame) {
      await axios.post('match-games', matchGame)
    },

    async update ({ commit }, matchGame) {
      await axios.patch(`/match-games/${matchGame.id}`, matchGame)
      commit('UPDATE_MATCH_GAME', matchGame)
    },

    async delete ({ commit }, id) {
      await axios.delete(`/match-games/${id}`)
      commit('DELETE_MATCH_GAME', id)
    },

    async result ({ commit }, params) {
      let result = await axios.patch(`/match-games/${params.id}/result`, params)
      params = Object.assign(params, result)
      commit('UPDATE_MATCH_GAME', params)
    },

    async rollback ({ commit }, params) {
      await axios.patch(`/match-games/${params.id}/rollback`, params)
      commit('UPDATE_MATCH_GAME', { id: params.id, status: 'N' })
    }
  }
}
